import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';

export default class ViewOrderUrlComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        const secutixCookie = Cookies.get('secutixConfig');
        if (secutixCookie !== undefined) {
            const secutixConfiguration = JSON.parse(secutixCookie);
            const params = new URLSearchParams(window.location.search);
            const fileName = params.get('FileNumber');
			this.element.setAttribute('href', secutixConfiguration.viewOrderUrl.replace('{0}', fileName));
        }
    }
}
